import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  clearBrowserSessionCookies,
  storeAuthHeaders,
} from 'dashboard/store/utils/api';
import { hasAuthCookie } from './AuthHelper';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { replaceRouteWithReload } from './CommonHelper';
import Cookies from 'js-cookie';

const refreshSessionCookieFromValidation = (
  response,
  currentSessionInfo = {}
) => {
  const rotatedSessionInfo = {
    ...currentSessionInfo,
    'access-token':
      response.headers.get('access-token') ||
      currentSessionInfo['access-token'],
    'token-type':
      response.headers.get('token-type') || currentSessionInfo['token-type'],
    client: response.headers.get('client') || currentSessionInfo.client,
    expiry: response.headers.get('expiry') || currentSessionInfo.expiry,
    uid: response.headers.get('uid') || currentSessionInfo.uid,
  };

  if (
    !rotatedSessionInfo['access-token'] ||
    !rotatedSessionInfo['token-type'] ||
    !rotatedSessionInfo.client ||
    !rotatedSessionInfo.uid
  ) {
    return;
  }

  storeAuthHeaders(rotatedSessionInfo);
};

const validateTokenFromSessionInfo = async () => {
  try {
    const raw = Cookies.get('cw_d_session_info');
    if (!raw) return false;
    const parsed = JSON.parse(raw || '{}') || {};
    const accessToken = parsed['access-token'];
    const tokenType = parsed['token-type'];
    const client = parsed.client;
    const expiry = parsed.expiry;
    const uid = parsed.uid;

    if (!accessToken || !tokenType || !client || !uid) return false;

    const response = await fetch('/auth/validate_token', {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'access-token': accessToken,
        'token-type': tokenType,
        client,
        expiry,
        uid,
      },
    });

    if (response.ok) {
      refreshSessionCookieFromValidation(response, parsed);
    }

    return response.ok;
  } catch {
    return false;
  }
};

const validateSSOLoginParams = to => {
  const isLoginRoute = to.name === 'login';
  const { email, sso_auth_token: ssoAuthToken } = to.query || {};
  const hasValidSSOParams = email && ssoAuthToken;
  return isLoginRoute && hasValidSSOParams;
};

export const validateRouteAccess = (to, next, chatwootConfig = {}) => {
  // Pages with ignoreSession:true would be rendered
  // even if there is an active session
  // Used for confirmation or password reset pages
  if (to.meta && to.meta.ignoreSession) {
    next();
    return;
  }

  if (validateSSOLoginParams(to)) {
    clearBrowserSessionCookies();
    next();
    return;
  }

  // Redirect to dashboard if a cookie is present, the cookie
  // cleanup and token validation happens in the application pack.
  if (hasAuthCookie()) {
    validateTokenFromSessionInfo().then(isValid => {
      if (isValid) {
        replaceRouteWithReload(DEFAULT_REDIRECT_URL);
        return;
      }

      // Prevent infinite bounce between /app/login and /app/ when
      // cw_d_session_info exists but token is invalid/unreachable.
      clearBrowserSessionCookies();
      next();
    });
    return;
  }

  // If the URL is an invalid path, redirect to login page
  // Disable navigation to signup page if signups are disabled
  // Signup route has an attribute (requireSignupEnabled) in it's definition
  const isAnInalidSignupNavigation =
    chatwootConfig.signupEnabled !== 'true' &&
    to.meta &&
    to.meta.requireSignupEnabled;

  if (!to.name || isAnInalidSignupNavigation) {
    next(frontendURL('login'));
    return;
  }

  next();
};

export const isOnOnboardingView = route => {
  const { name = '' } = route || {};

  if (!name) {
    return false;
  }

  return name.includes('onboarding_');
};
